import { useContext } from 'react';

import * as glob from '../Misc/Globals.js';
import {copyBuildLink, parseBuildQuery} from "../Misc/BuildImportExport.js";

import {BuilderStateContext} from '../Contexts/BuilderStateContext.jsx'
import {BuilderStateDispatchContext} from '../Contexts/BuilderStateContext.jsx'

import ACAssembly from './ACAssembly.jsx';
import PartsExplorer from './PartsExplorer.jsx';
import PartStats from './PartStats.jsx';
import ACStats from './ACStats.jsx';
import AssemblyImage from './AssemblyImage.jsx';
import {Title, InfoButton} from './Title.jsx';
import InfoBox from './InfoBox.jsx';

const buildLoaderTooltip = 'Insert a build link generated by the CREATE BUILD LINK ' +
	'button. This is equivalent to pasting a link in the address bar except ' +
	'it doesn\'t reset the state of the site.';

const BuildComponent = () => {

	const state = useContext(BuilderStateContext);
	const stateDispatch = useContext(BuilderStateDispatchContext);

	const preview = state.preview;
	const acParts = state.parts;
	const inputFieldString = state.inputFieldString;

	const setInputFieldString = event => stateDispatch(
		{target: 'inputFieldString', value: event.target.value}
	);
	const inputHandler = (event, pos) => {
		event.preventDefault();
		let query;
		try {
			const url = new URL(event.currentTarget[0].value);
			const params = new URLSearchParams(url.search);
			query = params.get('build')
		} catch {
			query = ''
		}
		const build = parseBuildQuery(query);
		stateDispatch({target: 'allParts', value: build})
	}

	let comparedParts;
	if(preview.part === null)
		comparedParts = null
	else {
		comparedParts = {...acParts};
		comparedParts[preview.slot] = preview.part;
		if(comparedParts.legs['LegType'] === 'Tank') {
			comparedParts.booster = glob.noneBooster
		} else if(
			comparedParts.legs['LegType'] !== 'Tank' && 
			comparedParts.booster['ID'] === glob.noneBooster['ID']
		) {
			// This happens when the current AC has tank legs and the preview has non-tank legs
			comparedParts.booster = glob.defaultBooster;
		}
	}

	return(
		<>
		<div style={
			{display: 'inline-block', width: '65%', verticalAlign: 'top'}
		}>
		{
			preview.slot === null ?
				<>
				<div style={{display:'inline-block', width: '35%', marginTop: '40px'}}>
					<div style={
						{
							...glob.dottedBackgroundStyle(),
							...{display: 'flex', width: '99%', height: '45px', 
								margin: '0px auto 5px auto', 
								border: 'solid 2px ' + glob.paletteColor(4)}
						}
					}>
						<div style={{display: 'flex', width: '100%', justifyContent: 'center', 
							alignItems: 'center', gap: '5px', padding: '0px 0px 0px 0px'}}>
							<div style={{width: '16px'}}>
								<InfoBox name={'build-loader-infobox'} tooltip={buildLoaderTooltip}
									place='bottom-start'/>
							</div>
							<div style={{width: 'auto'}}>BUILD LINK:</div>
							<form onSubmit={inputHandler}>
								<input
									className='link-tooltip-anchor'
									style={{width: '130px', height: '30px', 
										backgroundColor: glob.paletteColor(3)}}
									value={inputFieldString}
									onChange={setInputFieldString}
								/>
							<input type="submit" value="LOAD" 
								style={{marginLeft: '10px', padding: '3px 10px'}}/>
							</form>		
						</div>
					</div>				
					<ACAssembly
						parts={acParts}
						previewSetter={slot => stateDispatch({target: 'preview', slot: slot})}
					/>
					<div style={{display: 'flex', width: '100%', height: '50px', 
						background: glob.paletteColor(3)}}>
						<button style={{margin: 'auto'}} onClick={() => copyBuildLink(acParts)}>
							CREATE BUILD LINK
						</button>
					</div>
				</div>
				<div style={{display:'inline-block', verticalAlign: 'top', width: '65%'}}>
					<div style={{marginTop: '25px'}}>
						<Title />
					</div>
					<div style={{width: '100%', height: '571px'}}>
						<AssemblyImage />
					</div>
					<InfoButton />
				</div>
				</> 
				:
				<>
				<div style={
					{display: 'inline-block', width: '30%', verticalAlign: 'top'}
				}>
					<PartsExplorer />
				</div>
				<div style={
					{display: 'inline-block', width: '65%', verticalAlign: 'top', 
						marginLeft: '2.5%', marginRight: '2.5%', marginTop: '35px'}
				}>
					<PartStats />
				</div>
				</>
		}
		</div>
		<div style={
			{display: 'inline-block', width: '35%', marginTop: '35px', verticalAlign: 'top',
				height: '805px'}
		}>
			<ACStats acParts={acParts} comparedParts={comparedParts}/>
		</div>
		</>
	)
}

export default BuildComponent;